import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hint" }
const _hoisted_2 = {
  key: 0,
  class: "hint__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isShowHintTitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title || _ctx.hintInfo.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_ctx.hintInfo && _ctx.hintInfo.description)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 1,
          content: _ctx.hintInfo.description,
          placement: "top",
          effect: "light"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_InfoFilled)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content"]))
      : _createCommentVNode("v-if", true)
  ]))
}